module.exports = __webpack_public_path__ + "img/icon-02-guides.78ef741c.svg";